// extracted by mini-css-extract-plugin
module.exports = {"button":"CatFetchButton_button__qgRCn","fa-sync-alt":"CatFetchButton_fa-sync-alt__3kOEU"};